import { DecodedToken, User } from '@/types/auth'

// Decode JWT token
export function decodeToken(token: string): DecodedToken {
  const base64Url = token.split('.')[1]
  if (!base64Url) throw new Error('Invalid token format')
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  return JSON.parse(window.atob(base64))
}

export function createUserFromJWT(token: string): User {
  const decoded = decodeToken(token)
  const jwtDomains = decoded.domains || {}

  const userDomains = Object.keys(jwtDomains).map((tenantName) => ({
    tenant_name: tenantName,
    granted_by: 'jwt',
    granted_on: new Date().toISOString(),
    roles: jwtDomains[tenantName]?.roles || [],
  }))

  const hasGravitateAccess = userDomains.some(
    (domain) => domain.tenant_name === 'Gravitate',
  )

  return {
    email: decoded.sub,
    name: '',
    domains: userDomains,
    scopes: decoded.scopes || [],
    hasGravitateAccess,
    disabled: false,
    source: 'JWT',
    email_confirmed: true,
    is_active: true,
  }
}
